import React, { useEffect, useState } from "react";
import { NavBar, SideNav } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { fetchTemplates } from "../../redux/slices/templates";
import EditTemplateMetaModal from "../ViewTemplate/EditTemplateMetaModal";
import { createTemplate } from "../../redux/slices/templates";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import { AiFillPlusCircle } from "react-icons/ai";

const SkeletonLoader = () => (
  <div className="animate-pulse">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="p-4 bg-white dark:bg-gray-800 rounded-xl border dark:border-gray-700 space-y-4"
        >
          <div className="h-8 w-8 bg-gray-200 rounded-full dark:bg-gray-700"></div>
          <div className="h-4 bg-gray-200 rounded dark:bg-gray-700 w-1/2"></div>
          <div className="h-6 bg-gray-200 rounded dark:bg-gray-700 w-1/3"></div>
        </div>
      ))}
    </div>
  </div>
);

const ListTemplates = () => {
  const dispatch = useDispatch();
  const templatesStore = useSelector((state) => state.templates);
  const navigate = useNavigate();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchTemplates());
  }, [dispatch]);

  const handleViewDetails = (id) => {
    navigate(`/templates/${id}`);
  };

  const handleCreateTemplateClicked = () => {
    setIsCreateModalOpen(true);
  };

  return (
    <div className="antialiased bg-gray-50 dark:bg-gray-900 min-h-screen">
      <NavBar />
      <SideNav />
      <main className="p-4 md:ml-64 h-auto pt-20">
        <div className="sticky top-14 z-10 bg-gray-50 dark:bg-gray-900">
          <Breadcrumb />
        </div>
        <>
          <section className="mb-6">
            <div className="flex items-center">
              <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                Templates
              </h2>
              <AiFillPlusCircle
                onClick={() => handleCreateTemplateClicked()}
                className="ml-2 text-2xl text-purple-500 dark:text-gray-400 cursor-pointer hover:text-purple-600"
              />
            </div>
          </section>
          {templatesStore.pageLoading ? (
            <SkeletonLoader />
          ) : templatesStore.templates.length === 0 ? (
            <p className="text-gray-500 italic">No templates found.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {templatesStore.templates.map((template) => (
                <div
                  key={template.id}
                  className="group p-5 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl"
                >
                  <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">
                    {template.name}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                    {template.description}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
                    Created:{" "}
                    {new Date(
                      template.createdAt._seconds * 1000
                    ).toLocaleDateString()}
                  </p>
                  <button
                    onClick={() => handleViewDetails(template.id)}
                    className="text-sm text-purple-600 dark:text-cyan-300 hover:underline font-medium"
                  >
                    View Details →
                  </button>
                </div>
              ))}
            </div>
          )}
          <EditTemplateMetaModal
            isOpen={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            name=""
            description=""
            isNew={true}
            onSave={async ({ name, description }) => {
              const resultAction = await dispatch(
                createTemplate({ name, description, tasks: [] })
              );
              const newTemplateId = resultAction.payload?.id;
              if (newTemplateId) {
                navigate(`/templates/${newTemplateId}`);
              }
              setIsCreateModalOpen(false);
            }}
          />
        </>
      </main>
    </div>
  );
};

export default ListTemplates;
